import { courier } from '@/api/index'

export function warehousingDetails (data) {
  return courier.request({
    method: 'post',
    url: '/warehousingDetails',
    data,
    iSFromData: true
  })
}
export function getCourierDetailsData (data) {
  return courier.request({
    method: 'post',
    url: '/Get_CourierDetailsData',
    data,
    iSFromData: true
  })
}
export function addBKDorder (data) {
  return courier.request({
    method: 'post',
    url: '/ADD_B_KD_ORDER',
    data,
    iSFromData: true
  })
}

export function ordeRenterInfoWid (data) {
  return courier.request({
    method: 'post',
    url: '/ORDERENTERInfo_wid',
    data
    // iSFromData: true
  })
}

export function scanCode (data) {
  return courier.request({
    method: 'post',
    url: '/ScanCode',
    data,
    iSFromData: true
  })
}
export function Del_B_KD_ORDER (data) {
  return courier.request({
    method: 'post',
    url: '/Del_B_KD_ORDER',
    data,
    iSFromData: true
  })
}
export function ADD_B_KD_ORDER_detail (data) {
  return courier.request({
    method: 'post',
    url: '/ADD_B_KD_ORDER_detail',
    data,
    iSFromData: true
  })
}
export function B_KD_ORDER_detail (data) {
  return courier.request({
    method: 'post',
    url: '/B_KD_ORDER_detail',
    data,
    iSFromData: true
  })
}
export function warehousingManagement (data) {
  return courier.request({
    method: 'post',
    url: '/warehousingManagement',
    data,
    iSFromData: true
  })
}
